import { PosIconProps, SvgWrapper } from 'src/svgs/SvgWrapper';

export function ChevronEndIconV2(props: PosIconProps) {
  return (
    <SvgWrapper
      aria-label="ChevronEndIcon"
      fill="currentColor"
      {...props}
      viewBox="8 6 8 12"
    >
      <path
        d="M8.75 16.75L13.25 11.75L8.75 6.75"
        stroke="currentColor"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M15.5 7V17"
        stroke="currentColor"
        strokeLinecap="round"
        fill="none"
      />
    </SvgWrapper>
  );
}
